import { ChangeEvent, KeyboardEvent } from 'react';

interface UseSearchFieldParams {
  onChange: (value: string) => void;
  onClear: () => void;
  onEnter?: () => void;
}

export const useSearchField = ({ onChange, onClear, onEnter }: UseSearchFieldParams) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      onEnter?.();
    }
  };

  const handleClearKeyDown = (event: KeyboardEvent<HTMLSpanElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onClear();
    }
  };

  return {
    handleChange,
    handleKeyDown,
    handleClearKeyDown,
  };
};
